import Backbone from 'backbone'

const RoleModel = Backbone.Model.extend({
    defaults: {
        name: null,
    },
})

export default RoleModel
